
export const defaultSolutionContextWidgetData = {"constraints":{"Loading 1...":"Loading 2...","Loading 3..." : "Loading 4..."}};